// @ts-nocheck

import { BasketActionTypes } from '../../../types/actions/basket';

export const basketItemSetKLEligibleCollectible = ({ oddsId, collectibleId }) => ({
  type: BasketActionTypes.SET_ITEM_KL_ELIGIBLE_COLLECTIBLE,
  payload: {
    oddsId,
    collectibleId,
  },
});

export const basketSetKLEligibleCollectible = ({ collectibleId }) => ({
  type: BasketActionTypes.SET_KL_ELIGIBLE_COLLECTIBLE,
  payload: { collectibleId },
});

export const resetKLEligibleCollectibles = () => ({
  type: BasketActionTypes.RESET_KL_ELIGIBLE_COLLECTIBLES,
});
